var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('await',{attrs:{"name":"searchQuery","spinnerScale":0.75}},[_c('button',{staticClass:"it-filter-search",on:{"click":_vm.searchEvent}},[_c('i',{staticClass:"icon icon-magnifier"}),_vm._v("\n    "+_vm._s(_vm.$t('app.search'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }